import { render, staticRenderFns } from "./NormalSearchNav595.vue?vue&type=template&id=2b4b4a9a&scoped=true&"
import script from "./NormalSearchNav595.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav595.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b4a9a",
  null
  
)

export default component.exports